import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=f9168dd8&scoped=true"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=f9168dd8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9168dd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9168dd8')) {
      api.createRecord('f9168dd8', component.options)
    } else {
      api.reload('f9168dd8', component.options)
    }
    module.hot.accept("./ContextMenu.vue?vue&type=template&id=f9168dd8&scoped=true", function () {
      api.rerender('f9168dd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/repositorio/ContextMenu.vue"
export default component.exports